exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-tmp-benefits-jsx": () => import("./../../../src/templates/tmp-benefits.jsx" /* webpackChunkName: "component---src-templates-tmp-benefits-jsx" */)
}

